"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const React = __importStar(require("react"));
// components
const teamsnap_ui_1 = require("@teamsnap/teamsnap-ui");
const delete_confirmation_1 = __importDefault(require("components/common/delete-confirmation"));
const household_edit_1 = __importDefault(require("./household-edit"));
const household_member_card_1 = __importDefault(require("./household-member-card"));
const household_name_1 = __importDefault(require("./household-name"));
// selectors
const households_1 = require("selectors/households");
// models
// import Household from "models/household"; missing dependecy
const api_1 = require("core/api");
// helpers
const view_utils_1 = require("utils/view-utils");
const household_ts1_cta_card_1 = require("./household-ts1-cta-card");
class HouseholdComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showLeaveConfirmation: false,
            showHouseholdEdit: false,
        };
        this.showHouseholdEdit = this.showHouseholdEdit.bind(this);
        this.closeHouseholdEdit = this.closeHouseholdEdit.bind(this);
    }
    onAdd = () => {
        const { onAddMemberClicked } = this.props;
        onAddMemberClicked();
    };
    showLeaveConfirmation = () => {
        this.setState({ showLeaveConfirmation: true });
    };
    hideLeaveConfirmation = () => {
        this.setState({ showLeaveConfirmation: false });
    };
    leaveHousehold = () => {
        const { household, currentProfile, deleteHouseholdPerson } = this.props;
        const householdPerson = (0, households_1.findPerson)(household, currentProfile.id);
        this.hideLeaveConfirmation();
        deleteHouseholdPerson(household, householdPerson, true);
    };
    showHouseholdEdit() {
        this.setState({ showHouseholdEdit: true });
    }
    closeHouseholdEdit() {
        this.setState({ showHouseholdEdit: false });
    }
    // renderMemberCards(household: Household, ownedByUser: boolean) {
    renderMemberCards(household) {
        const { currentProfile, deleteHouseholdPerson, resendInvite, deleteInvite, setSelectedMember, loadContactInfos, history, } = this.props;
        const members = (0, lodash_1.sortBy)(household.householdPeople, (hp) => !hp.isOrganizer, (hp) => hp.personId !== currentProfile.id, (hp) => (hp.person.userId ? 0 : 1), (hp) => (0, view_utils_1.fullName)(hp.person).toLowerCase(), (hp) => (0, view_utils_1.fullName)(hp.person));
        return (0, lodash_1.map)(members, (hp) => (React.createElement(household_member_card_1.default, { history: history, household: household, deleteHouseholdPerson: deleteHouseholdPerson, resendInvite: resendInvite, deleteInvite: deleteInvite, setSelectedMember: setSelectedMember, loadContactInfos: loadContactInfos, key: 'p' + hp.id, householdPerson: hp, profile: currentProfile })));
    }
    render() {
        const { showLeaveConfirmation, showHouseholdEdit } = this.state;
        const { household, ownedByUser, submitHouseholdForm } = this.props;
        return (React.createElement("div", { className: "household" },
            React.createElement("div", { className: "header Grid" },
                React.createElement("div", { className: "Grid-cell u-sizeFull u-xs-sizeFill u-padBottomMd u-xs-padBottomNone" },
                    React.createElement(household_name_1.default, { householdName: household.name, editable: ownedByUser, onEdit: this.showHouseholdEdit })),
                React.createElement("div", { className: "Grid-cell u-sizeFull u-xs-sizeFit u-textRight" },
                    ownedByUser && (React.createElement(teamsnap_ui_1.Button, { color: "primary u-sizeFull", icon: 'plus', onClick: this.onAdd }, "New Household Member")),
                    !ownedByUser && (React.createElement("div", { className: "u-inlineBlock" },
                        React.createElement(teamsnap_ui_1.Button, { mods: "cancel", icon: 'dismiss', onClick: this.showLeaveConfirmation },
                            "Leave ",
                            household.name,
                            " Household"),
                        showLeaveConfirmation && (React.createElement(delete_confirmation_1.default, { onCancel: this.hideLeaveConfirmation, onDelete: this.leaveHousehold, deleteText: "Leave" })))))),
            React.createElement("div", { className: "Grid Grid--withGutter" },
                this.renderMemberCards(household),
                this.props.user?.capabilities?.includes(api_1.UserCapability.NAVIGATION_GO_TO_TS1) && React.createElement(household_ts1_cta_card_1.HouseholdTs1CTACard, null)),
            showHouseholdEdit && (React.createElement(household_edit_1.default, { initialValues: { name: household.name }, id: household.id, submitHouseholdForm: submitHouseholdForm, closeHouseholdEdit: this.closeHouseholdEdit }))));
    }
}
exports.default = HouseholdComponent;
